import { Action, ActionReducer } from '@ngrx/store';

import * as actions from '../actions';

/**
 * The StorageSync state subtree shape
 */
export interface StorageSyncState {
  /**
   * Whether the state has been hydrated from storage
   */
  rehydrated: boolean;

  /**
   * If there is a loading action in progress
   */
  loading: boolean;
  appReady: boolean;
}

const initialState: StorageSyncState = {
  rehydrated: false,
  loading: false,
  appReady: false,
};

/**
 * Storage Sync reducer.
 *
 * This looks a bit different to what would normally happen inside a reducer.
 * The reason for this is the storage sync reducer operates on the entire global
 * state, not a particular subtree.
 *
 * @param state The current state
 * @param action The action that has occurred
 */

export function reducer(reducer): ActionReducer<any> {
  return (state: any = initialState, action: Action): any => {
    switch (action.type) {
      case actions.REQUEST_REHYDRATE:
        return Object.assign({}, state, { storageSync: { rehydrated: false, loading: true } });

      case actions.RESPONSE_REHYDRATED:
        return Object.assign({}, state, (<actions.ResponseRehydrated>action).payload, {
          storageSync: { rehydrated: true, loading: false },
        });

      case actions.REQUEST_SAVE_TO_STORAGE:
        return Object.assign({}, state, { storageSync: { ...state.storageSync, loading: true } });

      case actions.RESPONSE_SAVE_TO_STORAGE:
        return Object.assign({}, state, { storageSync: { ...state.storageSync, loading: false } });

      case actions.ApplicationReady.type:
        return Object.assign({}, state, {
          storageSync: { ...state.storageSync, appReady: true },
        });

      case '@ngrx/store/init':
        return reducer({ ...state, storageSync: initialState }, action);
      default:
        return Object.assign({}, state, reducer(state, action));
    }
  };
}

export const getRehydrated = (state: StorageSyncState) => (state ? state.rehydrated : false);
export const isReady = (state: StorageSyncState) => (state ? state.appReady : false);
